(function(){
  if (window.__maCartFunctionalityFixLoadedV2) return;
  window.__maCartFunctionalityFixLoadedV2 = true;

  function updateCartCounts(count){
    var ids = ['CartCount','CartCountCavas'];
    ids.forEach(function(id){
      var el = document.getElementById(id);
      if (el) el.textContent = count;
    });
    document.querySelectorAll('.cart-count span, .site-header__cart-count span').forEach(function(el){
      el.textContent = count;
    });
  }

  function refreshMiniCart(){
    return fetch('/cart?view=json', { credentials: 'same-origin' })
      .then(function(response){ return response.text(); })
      .then(function(html){
        var target = document.getElementById('cart-info');
        if (target) target.innerHTML = html;
      })
      .catch(function(){});
  }

  function openCartCanvas(){
    refreshMiniCart().finally(function(){
      var desktopCart = document.getElementById('desktop_cart');
      if (desktopCart) {
        desktopCart.classList.add('active', 'item_count');
        desktopCart.style.visibility = 'visible';
        desktopCart.style.opacity = '1';
      }

      var canvas = document.querySelector('.block_cart_canvas');
      if (canvas) {
        canvas.classList.add('act', 'active');
      }

      var overlay = document.querySelector('.sidebar-overlay');
      if (overlay) {
        overlay.classList.add('act');
        overlay.classList.remove('d-none');
      }

      document.body.classList.add('cart_canvas_active');
    });
  }

  function submitProductForm(form, button){
    if (!form || form.__maSubmittingV2) return;
    form.__maSubmittingV2 = true;
    if (button) {
      button.classList.add('loading');
      button.style.pointerEvents = 'none';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(response){
      if (!response.ok) throw response;
      return response.json();
    })
    .then(function(item){
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(function(response){ return response.json(); });
    })
    .then(function(cart){
      updateCartCounts(cart.item_count);
      openCartCanvas();
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    })
    .catch(function(){
      form.submit();
    })
    .finally(function(){
      form.__maSubmittingV2 = false;
      if (button) {
        button.classList.remove('loading');
        button.style.pointerEvents = '';
      }
    });
  }

  document.addEventListener('click', function(event){
    var button = event.target.closest('button[name="add"], #AddToCart, .product-form__cart-submit, .btnAddToCart');
    if (!button) return;

    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    submitProductForm(form, button);
  }, true);

  document.addEventListener('submit', function(event){
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    submitProductForm(form, form.querySelector('button[name="add"], #AddToCart, .product-form__cart-submit, .btnAddToCart'));
  }, true);

  document.addEventListener('click', function(event){
    var close = event.target.closest('.close_cart, .sidebar-overlay.act');
    if (!close) return;
    var desktopCart = document.getElementById('desktop_cart');
    if (desktopCart) desktopCart.classList.remove('active');
    var overlay = document.querySelector('.sidebar-overlay');
    if (overlay) overlay.classList.remove('act');
    document.body.classList.remove('cart_canvas_active');
  }, true);
})();
